module.exports = __webpack_public_path__ + "media/images/athletes/4339-7bfb860eae54c7d4d683b3e02426414a.png";